import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["addTag"],
  _excluded2 = ["onChange", "value"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import AutosizeInput from 'react-input-autosize';
import { emailRegex, emailValidationMessage } from '../../../../formValidators';
import './AddCoworkersEmailInput.scss';

// Code snippet taken from https://github.com/olahol/react-tagsinput README
function autosizingRenderInput(_ref) {
  var addTag = _ref.addTag,
    props = _objectWithoutProperties(_ref, _excluded);
  var onChange = props.onChange,
    value = props.value,
    other = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(AutosizeInput, _extends({
    inputClassName: "invitation-email-input",
    type: "text",
    onChange: onChange,
    value: value
  }, other));
}
var AddCoworkersEmailInput = /*#__PURE__*/function (_Component) {
  function AddCoworkersEmailInput(props) {
    var _this;
    _classCallCheck(this, AddCoworkersEmailInput);
    _this = _callSuper(this, AddCoworkersEmailInput, [props]);
    _this.state = {
      error: ''
    };
    _this.handleEmailsChange = _this.handleEmailsChange.bind(_this);
    _this.handleValidationReject = _this.handleValidationReject.bind(_this);
    return _this;
  }
  _inherits(AddCoworkersEmailInput, _Component);
  return _createClass(AddCoworkersEmailInput, [{
    key: "handleValidationReject",
    value: function handleValidationReject(emails) {
      if (emails[0] !== '') {
        this.setState({
          error: emailValidationMessage
        });
      }
    }
  }, {
    key: "handleEmailsChange",
    value: function handleEmailsChange(newEmails) {
      var handleChange = this.props.handleChange;
      this.setState({
        error: ''
      }, function () {
        return handleChange(newEmails);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var emails = this.props.emails;
      var error = this.state.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-email-input-container"
      }, /*#__PURE__*/React.createElement(TagsInput, {
        value: emails,
        onChange: function onChange(newEmails) {
          return _this2.handleEmailsChange(newEmails);
        },
        addKeys: [9, 13, 32, 188, 186] // space, enter, tab, etc
        ,
        tagProps: {
          className: 'invitation-email-tag',
          classNameRemove: 'react-tagsinput-remove'
        },
        inputProps: {
          placeholder: emails.length > 0 ? '    ' : 'Type emails here'
        },
        onValidationReject: this.handleValidationReject,
        validationRegex: emailRegex,
        onlyUnique: true,
        renderInput: autosizingRenderInput,
        addOnBlur: true
      }), error && /*#__PURE__*/React.createElement("div", {
        className: "error-text"
      }, error));
    }
  }]);
}(Component);
AddCoworkersEmailInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func
};
AddCoworkersEmailInput.defaultProps = {
  handleChange: function handleChange() {}
};
export default AddCoworkersEmailInput;